import { SideNav, SideNavContent } from "components";
import { HomeWrapper } from "components/CdBalance/style";
import { HeaderDasNew, MainBody, Ptag } from "components/core";
import React, { useEffect, useState } from "react";
import http from "services/httpService";
import { healthIssuancePresent } from "utlis/utils";
import BufferCard from "./bufferCard";
import CbTable from "./CbTable";
import { OverlayLoader } from "components/core";
import PageHeader from "components/UniversalComponents/PageHeader";

function UniversalCorporateBuffer() {
  const company_name = localStorage.getItem("company_name");
  const [loader, setLoader] = useState(false);
  const [bufferData, setBufferData] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const userplan_id = healthIssuancePresent();
        const { data } = await http.post(
          "/business/get_corporate_buffer_data/",
          { userplan_id: userplan_id }
        );
        setBufferData(data);
      } catch (e) {
        console.log(e);
      } finally {
        setLoader(false);
      }
    };
    setLoader(true);
    fetchData();
  }, []);
  return (
    <>
      {loader ? (
        <OverlayLoader />
      ) : (
        <>
          <SideNav>
            <SideNavContent />
          </SideNav>
          <HeaderDasNew company_name={company_name} />
          <MainBody>
            <PageHeader header={"Corporate Buffer"} />
            <BufferCard details={bufferData} />
            {bufferData?.history_data?.length > 0 && (
              <CbTable tableData={bufferData.history_data} />
            )}
          </MainBody>
        </>
      )}
    </>
  );
}

export default UniversalCorporateBuffer;
